/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import PropTypes from 'prop-types';
import { FaEnvelope } from '@react-icons/all-files/fa/FaEnvelope';
import { FaComment } from '@react-icons/all-files/fa/FaComment';

import styles from './contact-content.module.scss';

const ContactContent = ({ email = 'support@sesport.dk' }) => (
  <div className={styles.container}>
    <div className={styles.icon}>
      <FaComment />
      <a href={`mailto:${email}`} target="_blank" rel="noreferrer nofollow" className="contact-gtm">
        <FaEnvelope />
        {email}
      </a>
    </div>
  </div>
);

export default ContactContent;

ContactContent.propTypes = {
  email: PropTypes.string,
};
